import {Routes} from '@angular/router';
import {ERouterPages, ERouterParams} from '@entities/router/router.enums';
import {isAuthenticatedGuard} from '@shared/guards/is-authenticated.guard';
import {isSubjectSlugGuard} from '@shared/guards/is-subject-slug.guard';

export const routes: Routes = [
  {
    path: ERouterPages.Welcome,
    loadComponent: () =>
      import('@pages/welcome/welcome.page').then((p) => p.WelcomePage),
    pathMatch: 'full',
  },
  {
    path: ERouterPages.Dashboard,
    loadComponent: () =>
      import('@pages/dashboard/dashboard.page').then((p) => p.DashboardPage),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: ERouterPages.Settings,
    loadComponent: () =>
      import('@pages/settings/settings.page').then((p) => p.SettingsPage),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: ERouterPages.Search,
    loadComponent: () =>
      import('@pages/search/pages/search/search.page').then(
        (p) => p.SearchPage
      ),
  },
  {
    path: ERouterPages.About,
    loadComponent: () =>
      import('@pages/about/about.page').then((p) => p.AboutPage),
  },
  {
    path: ERouterPages.Contacts,
    loadComponent: () =>
      import('@pages/contacts/contacts.page').then((p) => p.ContactsPage),
  },
  {
    path: ERouterPages.Sources,
    loadComponent: () =>
      import('@pages/sources/sources.page').then((p) => p.SourcesPage),
  },
  {
    path: `${ERouterParams.Slug}/${ERouterParams.Id}`,
    canMatch: [isSubjectSlugGuard],
    loadComponent: () =>
      import('@pages/dossier/pages/dossier-wrapper/dossier-wrapper.component').then(
        (p) => p.DossierWrapperComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@pages/dossier/pages/subject-dossier/subject-dossier.page').then(
            (p) => p.SubjectDossierPage
          ),
      },
      {
        path: `${ERouterPages.Branch}/${ERouterParams.BranchId}`,
        loadComponent: () =>
          import('@pages/dossier/pages/branch-dossier/branch-dossier.page').then(
            (p) => p.BranchDossierPage
          ),
      },
      {
        path: ERouterPages.Branch,
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('@pages/not-found/not-found.page').then((p) => p.NotFoundPage),
  },
];
